// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowUpWhite: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="7" viewBox="0 0 11 7" fill="currentColor">
            <polygon
                fill="#FFF"
                points="819.4 1378 818 1379.375 822.2 1383.5 818 1387.625 819.4 1389 825 1383.5"
                transform="matrix(0 -1 -1 0 1389 825)"
            />
        </svg>
    );
};

export default React.memo(IconArrowUpWhite);
